import React from 'react';
import {
  convertTime24To12,
  getCurrentDate,
  getCurrentDateAndTime,
} from 'core/utils/constants/DateTime';
import { PhotoNameCell } from 'core/components/SetupComponents/PhotoNameCell';
import { getName } from 'core/utils/setup';
import Avatar from 'assets/icons/Avatar.svg';

import { Tag } from 'core/components/Tag';
import {
  RoleColors,
  checkFileType,
  downloadFile,
  ifNotPreviousYear,
  maskEmailAddress,
  maskMobileNumber,
} from 'core/utils/constants';
import History from 'core/utils/history';

export const getListData = (
  url: string,
  setshowModal?,
  isDeleteAllowed?: boolean,
  isUpsertAllowed?: boolean
) => {
  let columns: any = [];
  if (url === 'academicYear') {
    // Academic Year
    columns = columns.concat([
      { header: 'Name', accessorKey: 'NAME' },
      {
        header: 'Start Date',
        accessorFn: row => row && getCurrentDate(row.START_DATE),
        id: 'START_DATE',
      },
      {
        header: 'End Date',
        accessorFn: row => row && getCurrentDate(row.END_DATE),
        id: 'END_DATE',
      },
      { header: 'Status', accessorKey: 'ACADEMIC_YEAR_STATUS' },
    ]);
  } else if (url === 'staffLeaveType') {
    // Branch Leave
    columns = columns.concat([
      { header: 'Name', accessorKey: 'NAME' },
      { header: 'Description', accessorKey: 'DESCRIPTION' },
      { header: 'Leave Count', accessorKey: 'LEAVE_COUNT' },
      { header: 'Paid Leave', accessorKey: 'IS_PAID_LEAVE' },
    ]);
  } else if (url === 'branchShift') {
    // Branch Shift
    columns = columns.concat([
      { header: 'Name', accessorKey: 'NAME' },
      {
        header: 'Start Time',
        accessorFn: row => row && convertTime24To12(row.START_TIME),
        id: 'START_TIME',
      },
      {
        header: 'End Time',
        accessorFn: row => row && convertTime24To12(row.END_TIME),
        id: 'END_TIME',
      },
    ]);
  }
  else if (url === 'class') {
    // Class
    columns = columns.concat([
      { header: 'Name', accessorKey: 'NAME' },
      { header: 'Class Code', accessorKey: 'CLASS_CODE' },
      { header: 'MindZit Class Code', accessorKey: 'MINDZIT_CLASS_CODE' },
      {
        header: 'Fee Payment Duration',
        accessorFn: row =>
          row && !!row?.FeePaymentDuration
            ? row?.FeePaymentDuration?.DURATION_NAME
            : '-',
        id: 'FeePaymentDuration',
      },
    ]);
  } else if (url === 'subject') {
    // Subject
    columns = columns.concat([
      {
        header: 'Name',
        accessorFn: row => row && row.SUBJECT_NAME,
        id: 'SUBJECT_NAME',
      },
    ]);
  } else if (url === 'student') {
    // Student
    columns = columns.concat([
      {
        header: 'Student Name',
        cell: tableProps => (
          <div className="flex items-center min-w-max">
            <img
              src={
                !!tableProps.cell.row.original?.PHOTO_URL
                  ? tableProps.cell.row.original?.PHOTO_URL +
                    `?random=${Math.random()}`
                  : Avatar
              }
              className="!w-10 !h-10 rounded-full object-cover mx-0"
              alt="PHOTO_URL"
            />
            <h1 className={`font-medium ml-2 w-fit`}>
              {getName([
                tableProps.cell.row?.original?.FIRST_NAME,
                tableProps.cell.row?.original?.LAST_NAME,
              ])}
            </h1>
          </div>
        ),
        id: 'FULLNAME',
      },
      {
        header: 'Mobile',
        id: 'MOBILE_NUMBER',
        accessorFn: row =>
          row && `${row.COUNTRY_CODE} ${maskMobileNumber(row?.MOBILE_NUMBER)}`,
      },
      {
        header: 'Email',
        id: 'EMAIL_ID',
        accessorFn: row => row && maskEmailAddress(row?.EMAIL_ID),
      },
      {
        header: 'Class',
        id: 'StudentClass',
        accessorFn: row => row && (row?.StudentClass?.Class?.NAME || '-'),
      },
      {
        header: 'Parent',
        cell: tableProps => (
          <div>
            {tableProps.cell.row.original?.Parent?.map((parent, index) => (
              <div key={'indexitem' + index}>
                <div className="flex">
                  <div className="text-md font-light  min-w-max">
                    {parent?.FIRST_NAME}
                    {parent?.LAST_NAME}
                  </div>
                </div>
              </div>
            )) || '--'}
          </div>
        ),
        id: 'PARENTFULLNAME',
      },
      {
        header: 'PEN',
        id: 'PERMANENT_EDUCATION_NUMBER',
        accessorFn: row => row && (row?.PERMANENT_EDUCATION_NUMBER || "-"),
      }/* ,
      {
        header: 'Mindzit',
        id: 'Mindzit',
        cell: tableProps => (
          <button
            onClick={e => {
              e.stopPropagation();
              studentMindzitURL(tableProps.cell.row.original);
            }}
            className="bg-primary-main text-neutral-light px-2 py-1 rounded-lg"
          >
            Mindzit
          </button>
        ),
      }, */
    ]);
  }   else if (url === 'staff') {
    // Staff
    columns = columns.concat([
      {
        header: 'Staff Name',
        cell: tableProps => (
          <div className="flex items-center min-w-max">
            <img
              src={
                !!tableProps.cell.row.original?.PHOTO_URL
                  ? tableProps.cell.row.original?.PHOTO_URL +
                    `?random=${Math.random()}`
                  : Avatar
              }
              className="!w-10 !h-10 rounded-full object-cover mx-0"
              alt="PHOTO_URL"
            />
            <h1 className={`font-medium ml-2 w-fit`}>
              {tableProps.cell.row?.original?.STAFF_NAME || getName([
                tableProps.cell.row?.original?.FIRST_NAME,
                tableProps.cell.row?.original?.LAST_NAME,
              ])}
            </h1>
          </div>
        ),
        id: 'FULLNAME',
      },
      { header: 'Gender', id: 'GENDER', accessorFn: row => row && row?.GENDER },
      {
        header: 'Mobile',
        id: 'MOBILE_NUMBER',
        accessorFn: row =>
          row && (row?.MOBILE_NUMBER && row?.COUNTRY_CODE) && `${row?.COUNTRY_CODE} ${maskMobileNumber(row?.MOBILE_NUMBER)}`,
      },
      {
        header: 'Email',
        id: 'EMAIL_ID',
        accessorFn: row => row && maskEmailAddress(row?.EMAIL_ID),
      },
      {
        header: 'Roles',
        cell: tableProps => (
          <div className="flex gap-1 flex-wrap">
            {(tableProps.cell.row.original?.STAFF_ROLES &&
              tableProps.cell.row.original.STAFF_ROLES.map((_item, _index) => (
                <Tag
                  className={`${RoleColors(
                    (_item?.BranchRole?.BRANCH_ROLE_ID || _item?.BRANCH_ROLE_ID),
                  )}  mx-1 p-1 text-xs`}
                  label={(_item?.BranchRole?.NAME || _item?.BRANCH_ROLE_NAME)}
                />
              ))) ||
              '-'}
          </div>
        ),
        id: 'STAFFROLES',
      }/* ,
      {
        header: 'Mindzit',
        id: 'Mindzit',
        cell: tableProps => (
          <button
            onClick={e => {
              e.stopPropagation();
              staffMindzitURL(tableProps.cell.row.original);
            }}
            className="bg-primary-main text-neutral-light px-2 py-1 rounded-lg"
          >
            Mindzit
          </button>
        ),
      }, */
    ]);
  }
 

  return columns;
};
